module.exports = __webpack_public_path__ + "img/icon-copiar.f13bda12.svg";